<template>
  <div class="wishlist-basketbutton">
    <b-button v-if="!wishListItemIds.includes(productId)" class="basketbutton" :title="resolvedAddTitle" variant="custom" @click.stop="addToCart">
      <b-icon icon="b-heart" />
    </b-button>
    <b-button v-else class="basketbutton" :title="resolvedRemoveTitle" variant="custom" @click.stop="removeFromCart">
      <b-icon icon="b-heart-fill" />
    </b-button>
  </div>
</template>

<script>
let hasRequestedWishlistMinimal = false

export default {
  name: 'WishListBasketButton',
  props: {
    productId: {
      type: String,
      required: true
    },
    basketButtonText: {
      type: String,
      default: ''
    },
    basketButtonRemoveText: {
      type: String,
      default: ''
    }
  },
  computed: {
    resolvedAddTitle () {
      return this.basketButtonText || this.$T('WishListBasketButtonText')
    },
    resolvedRemoveTitle () {
      return this.basketButtonRemoveText || this.$T('WishListBasketRemoveButtonText')
    },
    wishListItemIds () {
      const basket = this.$store.getters['wishlistcart/get']
      return (basket && basket.containedItemExternalIds) || []
    }
  },
  methods: {
    addToCart () {
      this.$store.dispatch('wishlistcart/addItem', { productId: this.productId })
    },
    removeFromCart () {
      this.$store.dispatch('wishlistcart/removeItem', { productId: this.productId, omitLastAction: true })
    }
  },
  created () {
    if (hasRequestedWishlistMinimal) return

    hasRequestedWishlistMinimal = true
    this.$store.dispatch('wishlistcart/getMinimal')
      .catch(() => {
        hasRequestedWishlistMinimal = false
      })
  }
}
</script>

<style lang="scss">
.wishlist-basketbutton {
  position: absolute;
  top: 0;
  right: 0;
  width: 45px;
  height: 45px;

  .basketbutton {
    @include button-variant($primary, transparent, darken($primary, 5%), transparent);
    display: flex;
    justify-content: center;
    align-items: center;
    padding: $btn-padding-y * 0.4 $btn-padding-y * 0.4;
    height: 100%;
    width: 100%;
  }
}
</style>

